import { defineStore } from "pinia";
import { useNuxtApp } from "nuxt/app";
const _removeItemFromWishList = (state, id) => {
  const index = state.items.findIndex((i) => i.id === id);
  if (index > -1) {
    state.items.splice(index, 1);
  }
};
export const wishStore = defineStore("wishStore", {
  state: () => ({
    items: [],
    loading: {
      getWishlist: false,
      addItem: false,
      removeItem: false,
      clearList: false
    }
  }),
  actions: {
    async getWishList(params) {
      try {
        this.$state.loading.getWishlist = true;
        const { $api } = useNuxtApp();
        const res = await $api.wishApi.getWishlistItems(params);
        if (res) {
          this.$state.items = res;
          return res;
        }
      } catch (e) {
        console.error(e.url, e._data);
      } finally {
        this.$state.loading.getWishlist = false;
      }
    },
    async addToWishList({ id }) {
      try {
        this.$state.loading.addItem = true;
        const { $api } = useNuxtApp();
        const res = await $api.wishApi.addItemToWishlist({ id });
        if (res) {
          this.$state.items.push(res);
        }
        return res;
      } catch (e) {
        console.error(e.url, e._data);
      } finally {
        this.$state.loading.addItem = false;
      }
    },
    async removeItemFromWishList(id) {
      try {
        this.$state.loading.removeItem = true;
        const { $api } = useNuxtApp();
        const res = await $api.wishApi.removeItemFromWishlist(id);
        if (res) {
          _removeItemFromWishList(this.$state, id);
        }
        return res;
      } catch (e) {
        console.error(e.url, e._data);
        return false;
      } finally {
        this.$state.loading.removeItem = false;
      }
    },
    async clearWishList() {
      try {
        this.$state.loading.clearList = true;
        const { $api } = useNuxtApp();
        const res = await $api.wishApi.clearWishlist();
        if (res) {
          this.$state.items = [];
        }
        return true;
      } catch (e) {
        console.error(e.url, e._data);
        return false;
      } finally {
        this.$state.loading.clearList = false;
      }
    }
  },
  getters: {
    wishList: ({ items }) => items,
    wishlistCount: ({ items }) => items.length,
    loadingList: ({ loading }) => loading,
    isInWishlist: ({ items }) => (id) => items.some((i) => i.id === id)
  }
});
